export const blockedwordConstants = {

    FETCH_BLOCKEDWORDS_REQUEST: 'FETCH_BLOCKEDWORDS_REQUEST',
    FETCH_BLOCKEDWORDS_SUCCESS: 'FETCH_BLOCKEDWORDS_SUCCESS',
    FETCH_BLOCKEDWORDS_FAILURE: 'FETCH_BLOCKEDWORDS_FAILURE',

    CREATE_BLOCKEDWORD_REQUEST: 'CREATE_BLOCKEDWORD_REQUEST',
    CREATE_BLOCKEDWORD_SUCCESS: 'CREATE_BLOCKEDWORD_SUCCESS',
    CREATE_BLOCKEDWORD_FAILURE: 'CREATE_BLOCKEDWORD_FAILURE',

    UPDATE_BLOCKEDWORD_REQUEST: 'UPDATE_BLOCKEDWORD_REQUEST',
    UPDATE_BLOCKEDWORD_SUCCESS: 'UPDATE_BLOCKEDWORD_SUCCESS',
    UPDATE_BLOCKEDWORD_FAILURE: 'UPDATE_BLOCKEDWORD_FAILURE',

    DELETE_BLOCKEDWORD_REQUEST: 'DELETE_BLOCKEDWORD_REQUEST',
    DELETE_BLOCKEDWORD_SUCCESS: 'DELETE_BLOCKEDWORD_SUCCESS',
    DELETE_BLOCKEDWORD_FAILURE: 'DELETE_BLOCKEDWORD_FAILURE',

}